import { MASTER_QUERY_KEY } from "@/lib/queryKeys";
import translation from "@/utils/translation_profile.json";
import { useQueryClient } from "@tanstack/react-query";
import { useCallback, useMemo, useState } from "react";

import { useMasterData as fetchMasterData } from "@/components/profile/query";

const useMasterData = () => {
  const [queryParams, setQueryParams] = useState({
    type: "",
    name: "",
    parentUuids: "",
    countryIsoCode: "",
  });

  const { data, refetch, isLoading } = fetchMasterData(
    queryParams.type,
    queryParams.name,
    queryParams.parentUuids,
    queryParams.countryIsoCode,
  );
  const queryClient = useQueryClient();

  const getMasterData = (
    type: string,
    inputText?: string,
    parentUuids?: string,
    countryIsoCode?: string,
  ) => {
    setQueryParams({
      type,
      name: inputText || "",
      parentUuids: parentUuids || "",
      countryIsoCode: countryIsoCode || "",
    });
    queryClient.setQueryData(
      [MASTER_QUERY_KEY, type, inputText, parentUuids, countryIsoCode],
      undefined,
    );
    refetch();
  };

  const getAdditionalData = useCallback((type: string, val: any) => {
    switch (type) {
      case "LOCATION":
      case "NATIONALITY":
        let id = "11e2b871-1b9e-48c0-a7a5-1174672ae846";
        return {
          extraInfo: {
            countryIsoCode: val?.country?.isoCode || "IN",
            countryName: val?.country?.name || "India",
            countryUuId: val?.country?.uuid || id,
          },
        };
      default:
        return {};
    }
  }, []);

  const updatedData = useMemo(() => {
    return (data?.data?.length ?? 0) > 0
      ? data?.data.map((val) => ({
          value: val.name,
          id: val.uuid,
          text: val.name,
          ...getAdditionalData(queryParams.type, val),
        }))
      : [];
  }, [data, queryParams.type, getAdditionalData]);

  if (
    queryParams.countryIsoCode !== "SG" &&
    queryParams.type === "VISA_TYPE" &&
    updatedData?.length
  ) {
    if (!updatedData.some((item) => item.id === "0")) {
      let text = translation.basic.iDontHaveAuth;
      updatedData.push({ id: "0", text, value: text });
    }
  }

  return { masterData: updatedData, getMasterData, isLoading };
};

export default useMasterData;
